const autoresponder = {
  readAutoresponders: 'autoresponder'
}

export default autoresponder
